import $ from 'jquery';

var regExpSpecialCharRE = /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,
    classNameSpecialCharRE = new RegExp("[!\"#$%&'()\*\+,/:;<=>\?@\[\\\]^`{\|}~ ]",'g'),
    classNameDotRE = /\./g;

// Very dirty way to patch an existing function

export function patch(func, prepend, replace) {
    var fd = func.toString().match(/^function\s*\(([^)]*)\)\{((?:.|\s)*)\}$/),
        fargs = fd[1].split(','),
        fbody = fd[2];

    Object.keys(replace).forEach(function(key) {
        fbody = fbody.replace(key, replace[key]);
    });

    return Function.apply(Object.create(Function.prototype), fargs.concat(prepend + fbody));
}

// Static property definition

export function staticDef(def) {
    if ( def === null || typeof def === 'undefined' || typeof def !== 'object' || (!def.hasOwnProperty('value') && !def.hasOwnProperty('get') &&  !def.hasOwnProperty('set'))) {
        def = {value: def};
    }
    def.enumerable = def.configurable = false;
    if (def.hasOwnProperty('value')) {
        def.writable = false;
    }
    return def;
}


// Escapes

export function regexEscape(str) {
    return str.replace(regExpSpecialCharRE, '\\$&')
}

export function safeClassname(str) {
    return str.replace(classNameDotRE,'_').replace(classNameSpecialCharRE, '');
}

// Array helpers

export function pushUnique(target, value) {
    if (!target.includes(value)) target.push(value);
}

// Path parser

export function pathHelper(sep, raw) {
    var escSep = (raw) ? sep : regexEscape(sep);

    return _pathHelper(
        new RegExp(escSep, 'g'),
        new RegExp('^.*' + escSep),
        new RegExp(escSep + '.*$'),
        new RegExp('^[^' + escSep + ']*' + escSep),
        new RegExp(escSep + '[^' + escSep +']*$'),
        new RegExp('^[^ ' + escSep + ']+(?:' + escSep + '[^ ' + escSep + ']+)+$')
    );
}

function _pathHelper(sepRegex, headPathRegex, tailPathRegex, headRegex, tailRegex, isPathRegex) {
    return {
        count: function(value) {
            return (value.match(sepRegex) || []).length;
        },
        
        getTail: function(value) {
            return value.replace(headPathRegex, '');
        },

        getHead: function(value) {
            return value.replace(tailPathRegex, '');
        },

        dropTail: function(value) {
            return value.replace(tailRegex, '');
        },

        dropHead: function(value) {
            return value.replace(headRegex, '');
        },

        isPath: function(value) {
            return isPathRegex.test(value);
        },

        getForPath: function(data, path) {
            if (typeof data == 'string' || data instanceof String) return data;
            if (data) {
                var sPath = path.split(sepRegex), len = sPath.length;
                for(var i=sPath.length - 1; i >= 0; i--) {
                    if (data.hasOwnProperty(sPath[i])) return data[sPath[i]];
                }
            }
            return null;
        }
    }
}

// Object traversal

export function traverseObjectTree(obj, callback, childFirstCallback, pathToObj, depth, key) {
    if (!pathToObj) {
        pathToObj = '';
        depth = 0;
    } else if ((!childFirstCallback && !callback.call(this, obj, pathToObj, depth, key) 
                || childFirstCallback && !childFirstCallback.call(this, obj, pathToObj, depth, key))
            || obj == null || obj === undefined
            || typeof obj != 'object') {
        return this;
    }

    var keys = Object.keys(obj);
    if (keys.length) {
        keys.forEach(function (key) {
            traverseObjectTree.call(this, obj[key], callback, childFirstCallback, (pathToObj) ? pathToObj.concat('.',key) : key, depth + 1, key);
        }, this);
    }

    if (childFirstCallback && pathToObj) {
        callback.call(this, obj, pathToObj, depth, key);
    }

    return this;
}

export function traverseObjects(baseObj, callback) {
    if (baseObj == null || baseObj === undefined || typeof baseObj != 'object') {
        return this;
    }

    var nextObjs = [{obj:baseObj, path:'', depth: 0}], nextObj;

    while (nextObj = nextObjs.shift()) {
        _traverseObject.call(this, nextObj.obj, callback, nextObj.path, nextObj.depth, nextObjs);
    }

    return this;
}

function _traverseObject(obj, callback, pathToObj, depth, nextObjs) {
    var keys = Object.keys(obj);
    if (keys.length) {
        keys.forEach(function (key) {
            var path = (pathToObj) ? pathToObj.concat('.',key) : key,
                sobj = obj[key];
            if (callback.call(this, sobj, path, depth + 1, key)
                && sobj != null && sobj !== undefined && typeof sobj == 'object') {
                nextObjs.push({obj: sobj,  path: path, depth: depth + 1});
            }
        }, this);
    }
}

// Create a custom Error class

export function createCustomError(name) {
    function CustomError(message, data) {
        var useData = (typeof data === 'object'),
            instance = useData ? new Error(message, data.fileName, data.lineNumber) 
                               : new Error(message, arguments[1], arguments[2]);
        if (useData) {
            delete data.fileName;
            delete data.lineNumber;
            instance.data = data;
        }
        Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
        if (Error.captureStackTrace) {
            Error.captureStackTrace(instance, CustomError);
        }
        return instance;
    }

    CustomError.prototype = Object.create(Error.prototype, {
        constructor: {
            value: Error,
            enumerable: false,
            writable: true,
            configurable: true
        }, name: {
            value: name,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });

    if (Object.setPrototypeOf){
        Object.setPrototypeOf(CustomError, Error);
    } else {
        CustomError.__proto__ = Error;
    }

    return CustomError;
}